import { takeLatest, select, call, put } from 'redux-saga/effects'
import { GET_CLOUD_RECORDS, SET_CLOUD_RECORDS, DELETE_CLOUD_RECORDS, DELETE_CLOUD_RECORDS_REQUEST, DELETE_CLOUD_RECORDS_SUCCESS, DELETE_CLOUD_RECORDS_FAILURE } from '../actions/type'
import { getHttpClient, postHttpClient, getSelector, genVRoomToken } from '../../helpers'
import { showSpinner, hideSpinner } from '../actions/actions'
import { isEmpty } from 'lodash';

const keycloakSelector = getSelector('keycloak')

function* getCloudRecords(action) {
  const { page, perPage, sortBy, startDate, endDate } = action
  const dataPeriod = startDate !== '' ? `&start_date=${startDate}&end_date=${endDate}` : ''
  const keycloak = yield select(keycloakSelector)
  const url = `${window._env_.cloudRecordingApiBaseURL}/api/public/v1/cloud-records/?page=${page}&perPage=${perPage}&sortBy=${sortBy}&filters[record_success]=1` + dataPeriod
  if (!isEmpty(keycloak)) {
    yield put(showSpinner)
    try {
      const token = yield call(genVRoomToken, keycloak)
      const response = yield call(getHttpClient, keycloak, url, { Authorization: "Bearer " + token })
      if (!isEmpty(response.data)) {
        yield put({
          type: SET_CLOUD_RECORDS,
          payload: response.data
        })
      }
    } catch (error) {
      console.error('cloudRecords', error)
    }
    yield put(hideSpinner)
  }
}

function* deleteCloudRecords(action) {
  const params = {
    record_ids: action.recordDelete
  }

  const keycloak = yield select(keycloakSelector)
  const url = `${window._env_.cloudRecordingApiBaseURL}/api/public/v1/cloud-records/delete-batch`
  if (!isEmpty(keycloak)) {
    yield put(showSpinner)
    try {
      yield put({
        type: DELETE_CLOUD_RECORDS_REQUEST
      })
      const token = yield call(genVRoomToken, keycloak)
      const response = yield call(postHttpClient, keycloak, url, { Authorization: "Bearer " + token, 'Content-Type': 'application/json' }, { ...params })

      if (response.data) {
        yield put({
          type: DELETE_CLOUD_RECORDS_SUCCESS,
          payload: response.data
        })
      } else {
        yield put({
          type: DELETE_CLOUD_RECORDS_FAILURE,
          payload: response.status.errorMessage
        })
      }
    } catch (error) {
      console.error('cloudRecords', error)
    }
    yield put(hideSpinner)
  }
}

function* cloudRecordsSaga() {
  yield takeLatest(GET_CLOUD_RECORDS, getCloudRecords)
  yield takeLatest(DELETE_CLOUD_RECORDS, deleteCloudRecords)
}

export default cloudRecordsSaga